import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=cc19ba3a&scoped=true&"
import script from "./Chapter.vue?vue&type=script&lang=js&"
export * from "./Chapter.vue?vue&type=script&lang=js&"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=cc19ba3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc19ba3a",
  null
  
)

export default component.exports